<template>
  <div v-cloak class="lb-portal" data-test-component="siteHeader">
    <site-header-large-screen v-if="large" :options="options" />
    <site-header-mobile v-else :options="options" />
    <div v-if="options && hasProperty(options, 'HiddenThirdPartyLinks')" class="hide">
      <a
        v-for="(link, index) in options.HiddenThirdPartyLinks"
        :key="'site-header' + index"
        :href="link.Url"
        v-text="link.Text"
      />
    </div>
  </div>
</template>
<script>
import BaseMixinVue from '@/components/Feature/BaseMixin.vue';
import { hasProperty } from '@/common/Util/utility.js';
import HeaderBaseMixinVue from './HeaderBaseMixin.vue';

import SiteHeaderLargeScreen from './SiteHeaderLargeScreen/SiteHeaderLargeScreen.vue';
import SiteHeaderMobile from './SiteHeaderSmallScreen/SiteHeaderSmallScreen.vue';

export default {
  name: 'SiteHeader',
  components: {
    SiteHeaderLargeScreen,
    'site-header-mobile': SiteHeaderMobile
  },
  mixins: [BaseMixinVue, HeaderBaseMixinVue],
  props: {
    isExperienceEditorProp: {
      type: Boolean,
      default() {
        return null;
      }
    },
    options: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {},
  watch: {},
  created() {
    this.$store.dispatch('general/changeIsExperienceEditor', this.isExperienceEditorProp);
  },
  mounted() {},
  methods: {
    hasProperty
  }
};
</script>
<style lang="scss" scoped>
@import 'header';
</style>
